import { Link } from "react-router-dom";
import { mockVideos } from "@/mocks/videos";

export default function HeroSection() {
  const featuredVideos = mockVideos.filter((v) => v.featured).slice(0, 4);

  return (
    <section className="relative w-full h-[520px] md:h-[620px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20warm%20gradient%20background%20with%20soft%20overlapping%20circles%20in%20coral%20orange%20and%20warm%20amber%20tones%2C%20modern%20minimal%20design%2C%20smooth%20texture%2C%20elegant%20atmospheric%20glow%2C%20subtle%20geometric%20patterns%2C%20clean%20professional%20aesthetic%2C%20no%20text&width=1920&height=900&seq=hero-bg-91chigua&orientation=landscape"
          alt="91吃瓜首页背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <div className="text-center max-w-3xl">
          <h1 className="font-heading text-3xl md:text-5xl font-bold text-white mb-4 leading-tight">
            最新吃瓜视频，尽在<span className="text-primary-400">91吃瓜</span>
          </h1>
          <p className="text-white/70 text-base md:text-lg mb-8 max-w-xl mx-auto">
            娱乐圈、社会热点、情感八卦、搞笑趣闻 — 高清视频在线观看，每日更新
          </p>
          <div className="flex items-center justify-center gap-3 flex-wrap">
            <Link
              to="/category/hot"
              className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white font-medium px-6 py-3 rounded-full text-sm transition-all whitespace-nowrap"
            >
              <i className="ri-fire-line"></i>
              热门吃瓜
            </Link>
            <Link
              to="/category/entertainment"
              className="inline-flex items-center gap-2 bg-white/15 hover:bg-white/25 text-white backdrop-blur-sm font-medium px-6 py-3 rounded-full text-sm transition-all whitespace-nowrap"
            >
              <i className="ri-movie-line"></i>
              娱乐圈
            </Link>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 w-full max-w-4xl">
          {featuredVideos.map((video) => (
            <Link
              key={video.id}
              to={`/article/${video.slug}`}
              className="group relative rounded-xl overflow-hidden aspect-video bg-background-900/40 backdrop-blur-sm"
            >
              <img
                src={video.thumbnail}
                alt={video.title}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-3">
                <p className="text-white text-xs font-medium line-clamp-2 leading-snug">{video.title}</p>
                <span className="text-white/60 text-[10px] mt-1 inline-block">{video.views.toLocaleString()} 次观看</span>
              </div>
              <div className="absolute top-2 right-2 bg-black/60 backdrop-blur-sm text-white text-[10px] px-1.5 py-0.5 rounded">
                {video.duration}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}